var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "base",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.49 279.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,\n      .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n      .cls-1 {\n        stroke: #5d3233;\n        stroke-width: 20px;\n      }\n      .cls-2 {\n        stroke: #3d3327;\n        stroke-width: 14px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.31,498.19s98.24-68.67,206,0",
    transform: "translate(-221.96 -228.61)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.64,241.85S493.47,214.61,550.45,274",
    transform: "translate(-221.96 -228.61)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229,274.43s39.2-51.63,117.36-25.89",
    transform: "translate(-221.96 -228.61)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.ab6c43c9.svg";
export { ForwardRef as ReactComponent };